
import { computed, defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AuditLogResourceHistory from '@/components/employees-audit-log/resource-history.vue'
import { EmployeeModel, useEmployeeModule } from '@/modules/employees'
import AuditLogOperatorActivities from '@/components/employees-audit-log/operator-activities.vue'
import { HistoryRecord } from '@/modules/_shared/audit-log/types'
import { EmployeeRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'view-employee-single-employee',
    components: {
        AuditLogOperatorActivities,
        AuditLogResourceHistory
    },
    async setup () {
        const {
            getSingleEmployee,
            getEmployeeHistory,
            getEmployeeActivities
        } = useEmployeeModule()
        const employee = ref<EmployeeModel>()
        const history = ref<HistoryRecord[]>([])
        const activities = ref<HistoryRecord[]>([])
        const route = useRoute()
        const router = useRouter()

        const employeeId = route.params.id as string

        getSingleEmployee(employeeId).then(loadedEmployee => {
            employee.value = loadedEmployee
        }).catch(() => router.go(-1))
        getEmployeeHistory(employeeId).then(loadedHistory => {
            history.value = loadedHistory
        })
        getEmployeeActivities(employeeId).then(loadedActivities => {
            activities.value = loadedActivities
        })
        return {
            activities,
            employee: computed(() => employee.value),
            history,
            EmployeeRouteNames,
            route
        }
    }
})
